<aside class="agu-rail" [attr.aria-labelledby]="TitleId">
    <div class="agu-rail__head">
        <span class="agu-rail__heading">
            <span class="agu-rail__title" [id]="TitleId">Filters</span>
            @if (ActiveCount > 0) {
                <span class="agu-rail__count">{{ ActiveCount }}</span>
            }
        </span>
        <button type="button" class="agu-rail__clear agu-hit-24" [disabled]="!CanClear" (click)="RequestClearAll()">Clear all</button>
    </div>

    <ng-content />
</aside>
